import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isDesktop, isMobile } from '@styles/breakpoints';

export enum UiStateActions {
  NAME = '@APP/UI_STATE',
  SET_IS_SERVER = '@APP/UI_STATE/setIsServer',
  SET_IS_MOBILE = '@APP/UI_STATE/setIsMobile',
  SET_IS_DESKTOP = '@APP/UI_STATE/setIsDesktop',
  SET_SHOW_SEARCH = '@APP/UI_STATE/setShowSearch'
}

export interface UiState {
  isServer: boolean;
  isMobile: boolean;
  isDesktop: boolean;
  showSearch: boolean;
}

export const INITIAL_UI_STATE: UiState = {
  isServer: typeof window === 'undefined',
  isMobile: isMobile(),
  isDesktop: isDesktop(),
  showSearch: false
};

const uiStateSlice = createSlice({
  name: UiStateActions.NAME,
  initialState: INITIAL_UI_STATE,
  reducers: {
    setIsServer(state, action: PayloadAction<boolean>) {
      state.isServer = action.payload;
    },
    setIsMobile(state, action: PayloadAction<boolean>) {
      state.isMobile = action.payload;
    },
    setIsDesktop(state, action: PayloadAction<boolean>) {
      state.isDesktop = action.payload;
    },
    setShowSearch(state, action: PayloadAction<boolean>) {
      state.showSearch = action.payload;
    }
  }
});

export const { setIsServer, setIsMobile, setIsDesktop, setShowSearch } = uiStateSlice.actions;

export const uiStateReducer = uiStateSlice.reducer;
